<template>
<section class="setup">
  <h2 class="setup__title">How to Install Secure VPN APK</h2>

  <div class="setup__steps">
    <article
      v-for="(step, index) in steps"
      :key="step.title"
      class="setup__step"
    >
      <div class="setup__copy">
        <span class="setup__badge" aria-hidden="true">{{ index + 1 }}</span>
        <div class="setup__text">
          <div class="setup__step-title">{{ step.title }}</div>
          <p>{{ step.desc }}</p>
        </div>
      </div>
      <div v-if="step.img" class="setup__media">
        <img :src="step.img" :alt="step.title" loading="lazy">
      </div>
    </article>
  </div>

  <p class="setup__note">
    Secure VPN is designed for Android devices and can be installed manually using the APK package. Make sure your device has enough free storage and allows installation from external sources.
  </p>
</section>
</template>

<script>
import setup1 from '@/assets/vpn/setup-1.webp'
import setup2 from '@/assets/vpn/setup-2.webp'

export default {
  name: 'SetupSection',
  data() {
    return {
      steps: [
        {
          title: 'Download the APK',
          desc: 'Tap the download button above to get the latest Secure VPN APK.',
          img: setup1,
        },
        {
          title: 'Allow APK Installation',
          desc: 'If Android blocks the installation, enable permission for your browser or file manager to install apps from unknown sources.',
          img: null,
        },
        {
          title: 'Install Secure VPN',
          desc: 'Open the downloaded APK and follow the installation instructions.',
          img: setup2,
        },
        {
          title: 'Connect to VPN',
          desc: 'Launch Secure VPN, select a server if available, and tap the connect button.',
          img: null,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.setup {
  padding: 28px 32px;
  border-radius: 24px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 241, 255, 0.98) 100%);
  box-shadow: 0 12px 32px rgba(109, 74, 255, 0.06);
  box-sizing: border-box;
}

.setup__title {
  margin: 0 0 24px;
  text-align: left;
  font-size: clamp(24px, 2.8vw, 32px);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--vpn-ink, #1f2430);
  font-weight: 800;
}

.setup__steps {
  display: grid;
  gap: 20px;
}

.setup__step {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: #fff;
  box-shadow: 0 8px 20px rgba(109, 74, 255, 0.04);
}

.setup__copy {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.setup__text {
  min-width: 0;
  flex: 1;

  .setup__step-title {
    margin: 0 0 8px;
    font-size: 20px;
    line-height: 1.3;
    font-weight: 800;
    color: var(--vpn-ink, #1f2430);
  }

  p {
    margin: 0;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 15px;
    line-height: 1.65;
  }
}

.setup__media {
  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 14px;
    box-shadow: 0 12px 28px rgba(80, 60, 140, 0.12);
  }
}

.setup__note {
  margin: 20px 0 0;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(109, 74, 255, 0.05);
  border: 1px solid var(--vpn-line, #e8e4f8);
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 14px;
  line-height: 1.65;
}

@media (max-width: 800px) {
  .setup {
    padding: 18px 14px;
    border-radius: 16px;
  }

  .setup__title {
    margin-bottom: 18px;
    font-size: clamp(20px, 5.5vw, 26px);
  }

  .setup__step {
    gap: 12px;
    padding: 14px;
  }

  .setup__badge {
    width: 34px;
    height: 34px;
    font-size: 14px;
  }

  .setup__text {
    .setup__step-title {
      font-size: 17px;
    }

    p {
      font-size: 14px;
    }
  }

  .setup__note {
    margin-top: 16px;
    padding: 12px 14px;
    font-size: 13px;
  }
}
</style>
